import ProductForm from './ProductForm.jsx';

export {
  ProductForm
}



// WEBPACK FOOTER //
// ./components/my-business/manage-product/index.js